import ModalStack from '@/components/Custom/ModalStack';

export default function MemberActionLayout() {
  return <ModalStack />;
}
